import { FeatureFlagConstant } from '@/global/types'
import { doc, getDoc, getFirestore } from 'firebase/firestore/lite'

import firebase from './setup'
import { FeatureFlag } from './types'

const getFeatureFlag = async ({
  namespace,
  key
}: FeatureFlagConstant): Promise<FeatureFlag> => {
  const firestore = getFirestore(firebase)
  const docRef = doc(firestore, `feature_configs/${namespace}-${key}`)
  const snapshot = await getDoc(docRef)
  const data = snapshot.data()

  if (!data)
    throw Error('Error getting firestore data. The snapshot data is undefined.')

  const featureFlag: FeatureFlag = {
    id: data.id,
    namespace: data.namespace,
    key: data.key,
    type: data.type,
    value: data.value,
    active: data.active
  }
  return featureFlag
}

export { getFeatureFlag }
